export function isENSNameFormatIgnoreCase(str) {
    return str.indexOf('.') > 0;
}
export function toENSName(str) {
    if (isENSNameFormatIgnoreCase(str)) {
        return str.toLowerCase();
    }
    throw new Error(`not a valid ENS name: "${str}"`);
}
//# sourceMappingURL=ENSName.js.map